/**
 * Csv Schema of TipoPessoaRecebedor
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {TipoPessoaRecebedor} from '@/model/resource/TipoPessoaRecebedor'

/* TODO: review generated schema */
export class CsvTipoPessoaRecebedorSchema extends Schema {
  readonly name = 'CsvTipoPessoaRecebedor'

  readonly fieldSet: FieldSet<TipoPessoaRecebedor> = {
    idTipoPessoaPk: schema => schema.model.idTipoPessoaPk,
    nome: schema => schema.model.nome,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
